import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

export const isItemInDraftsFolder = (folderId: string, parentFolderId: string): boolean => {
    const draftsId = folderNameToId('drafts');

    return folderId === draftsId || parentFolderId === draftsId;
};

export const isItemInSentItemsFolder = (folderId: string, parentFolderId: string): boolean => {
    const sentItemsId = folderNameToId('sentitems');

    return folderId === sentItemsId || parentFolderId === sentItemsId;
};

const isItemInSentOrDraftsFolder = (folderId: string, parentFolderId: string) =>
    isItemInDraftsFolder(folderId, parentFolderId) ||
    isItemInSentItemsFolder(folderId, parentFolderId);

export default isItemInSentOrDraftsFolder;
